/** @format */
import { getEnvUrlByUrl } from '@power/runtime-vue3';

import PcpMoMySystems from './index.vue';
export { PcpMoMySystems };

export function moToSubSystem(item: any) {
	//console.log('item', item);
	const { alias, openWay } = item;
	let homePage = item.homePage;
	if (homePage) {
		homePage = homePage.replaceAll('$token$', window.pData?.globalStore?.token || '');
	}

	if (!homePage) {
		homePage = `/${alias}/`;
	}

	const url = getEnvUrlByUrl(homePage);

	if ('curWindow' === openWay) {
		//  当前窗口打开
		window.location.href = url;
	} else {
		// 新开窗口打开
		window.open(url);
	}

	return;
}
